import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { updateUserState, updateUserStateFromKentico } from '../slices/user';
export function buildUserStateMiddleware(adapter) {
    const middleware = createListenerMiddleware();
    const runtimeStartListening = middleware.startListening;
    runtimeStartListening({
        matcher: isAnyOf(updateUserState, updateUserStateFromKentico),
        effect: (action, listenerApi) => {
            const state = listenerApi.getState();
            // only sync the contents up the update with the onUserStateChange adapter
            // this does require the adapter to be able to handle partial updates
            adapter(action.payload);
        },
    });
    return middleware;
}
//# sourceMappingURL=userState.js.map